export default __webpack_public_path__ + "static/media/logo-us-converse.6344c84d.svg";